import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import StorageService from '../../services/storageService';

type RouteExternalProps = {
  children: ReactNode;
  path: string;
};

const RouteExternal = ({ children, path }: RouteExternalProps) => {
  const token = StorageService.getAccessToken();
  
  return (!token ? children : <Navigate to="/dashboard" replace />);
}

export default RouteExternal;
